import RefreshOutlinedIcon from '@mui/icons-material/RefreshOutlined';
import { Box } from '@mui/material';
import { useVersionPolling } from '@/shared/hooks/useVersionPolling';
import Button from '@/shared/ui/primitives/Button';
import Typography from '@/shared/ui/typography/Text';

export const VersionUpdateBanner = () => {
  const { hasNewVersion } = useVersionPolling();

  const handleRefresh = () => {
    window.location.reload();
  };

  if (!hasNewVersion) {
    return null;
  }

  return (
    <Box
      sx={{
        backgroundColor: 'gx.response',
        marginBottom: 3,
        p: '8px 24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 1
      }}
    >
      <Typography>
        <Typography
          component='span'
          size={14}
          sx={{
            fontWeight: 'bold',
            marginRight: '12px'
          }}
        >
          New version available
        </Typography>
        <Typography
          size={14}
          component='span'
        >
          Please refresh the page to ensure optimal performance and access the latest features
        </Typography>
      </Typography>
      <Button
        sx={{ width: 250, fontSize: 14 }}
        variant='contained'
        onClick={handleRefresh}
      >
        <RefreshOutlinedIcon />
        Refresh now
      </Button>
    </Box>
  );
};
